








import Vue from 'vue';
import { LOAD_STATE } from '@/store/shared';
import * as mutations from '@/store/mutation-types';
import EventTimeline from '@/components/SubscriptionAnalytics/EventTimeline.vue';
import EventOverview from '@/components/SubscriptionAnalytics/EventOverview.vue';
import FeatureUsage from '@/components/SubscriptionAnalytics/FeatureUsage.vue';
import { FETCH_EVENT_FILTER_OPTIONS } from '@/store/action-types';

export default Vue.extend({
  name: 'EventDashboard',
  components: {
    FeatureUsage,
    EventOverview,
    EventTimeline,
  },
  data() {
    return {
      LOAD_STATE,
    };
  },
  async created() {
    this.$store.dispatch(FETCH_EVENT_FILTER_OPTIONS);
  },
});
